import ImageFrame from './ImageFrame'
import ImagePlaceholderFrame from './ImagePlaceholderFrame'

export class IndexResult {
  constructor (element, args) {
    let div = document.createElement('div')
    div.className = 'contact'
    div.onclick = args.onclick
    let image = null

    if (args.showImage !== false) {
      if (args.item && args.item.getImage && args.item.getImage()) {
        image = new ImageFrame(div, {
          image: args.item.getImage()
        })
      } else {
        image = new ImagePlaceholderFrame(div, {
          title: args.item ? args.item.getTitle() : null
        })
      }
    }

    let dl = document.createElement('dl')
    this.dt = document.createElement('dt')
    this.dt.innerHTML = args.title
    this.dd = document.createElement('dd')
    this.dd.innerHTML = args.subtitle

    dl.appendChild(this.dt)
    dl.appendChild(this.dd)
    div.appendChild(dl)

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)

    element.appendChild(fragment)
  }

  getTitle () {
    return this.dt.innerHTML
  }

  setTitle (text) {
    this.dt.innerHTML = text
  }

  getSubtitle () {
    return this.dd.innerHTML
  }

  setSubtitle (text) {
    this.dd.innerHTML = text
  }
}

export default class IndexList {
  constructor (element, args) {
    this.div = document.createElement('div')
    this.div.className = 'index'
    this.reverse = args.reverse
    this.showImage = args.showImage
    this.onclick = args.onclick    
    this.p = document.createElement('p')
    this.input = document.createElement('input')
    this.input.placeholder = 'Typ hier om te filteren'
    this.input.type = 'search'
    this.input.onkeydown = (e) => {
      if (event.keyCode === 13) {
        e.target.blur()
      }
    }
    this.items = []

    this.input.oninput = () => {
      this.refreshResults()
    }

    this.setItems(args.items)

    let fragment = document.createDocumentFragment()
    fragment.appendChild(this.div)
    this.div.appendChild(this.input)
    this.div.appendChild(this.p)

    element.appendChild(fragment)
  }

  getFilter () {
    return this.input.value
  }

  setFilter (filter) {
    this.input.value = filter
    this.refreshResults()
  }

  getItems () {
    return this.items
  }

  setItems (newItems) {
    this.div.classList.add('working')
    this.items = newItems

    new Promise((resolve) => {
      if (this.items) {
        this.items.sort((item, compareTo) => {
          if (item.getCompareString && compareTo.getCompareString) {
            return this.reverse ? compareTo.getCompareString().localeCompare(item.getCompareString())
              : item.getCompareString().localeCompare(compareTo.getCompareString())
          }

          return 0
        })

        resolve()
      } else {
        resolve()
      }
    }).then(() => {
      this.refreshResults()
      this.div.classList.remove('working')
    })
  }

  refreshResults () {
    let filter = this.getFilter().toLowerCase()
    let lastLabel = ''

    if (!this.items || !this.items.length) {
      this.p.innerHTML = 'Geen gegevens beschikbaar'
      this.input.className = 'invisible'
      this.input.disabled = true
      return
    }

    this.input.className = ''
    this.input.disabled = false

    let results = []

    this.p.innerHTML = ''

    this.items.forEach((item) => {
      let title = item ? item.getTitle() ? item.getTitle().toLowerCase() : 'onbekend' : ''
      let subtitle = item ? item.getSubtitle() ? item.getSubtitle().toLowerCase() : 'onbekend' : ''

      if (filter && title.indexOf(filter) === -1 && subtitle.indexOf(filter) === -1) {
        return
      }

      if (lastLabel !== item.getIndex()) {
        lastLabel = item.getIndex()
        let label = document.createElement('label')
        label.innerHTML = lastLabel
        this.p.appendChild(label)
      }

      results.push(new IndexResult(this.p, {
        title: item.getTitle(),
        subtitle: item.getSubtitle(),
        item: item,
        showImage: this.showImage,
        onclick: () => {
          if (this.onclick) {
            this.onclick(item)
          }
        }
      }))
    })

    if (filter && !results.length) {
      this.p.innerHTML = 'Filter geeft geen resultaten'
      return
    }
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/IndexControl.js